/*!
 *  __  __           _  ____   _____               _
 * |  \/  | __ _  __| |/ ___| |_   _| __ __ _  ___| | __
 * | |\/| |/ _` |/ _` | |  _    | || '__/ _` |/ __| |/ /
 * | |  | | (_| | (_| | |_| |   | || | | (_| | (__|   <
 * |_|  |_|\__,_|\__,_|\____|   |_||_|  \__,_|\___|_|\_\
 *
 * Allows you to put things like
 *
 * <a href="/get-a-quote"
 *     class="btn btn-primary"
 *     data-madg-event-category="CTA"
 *     data-madg-event-action="Click"
 *     data-madg-event-label="Home Hero Get a Quote">
 *     Get a Quote Today
 * </a>
 *
 * in your html markup. Put these data attributes on all important buttons/CTAs,
 * so they get tracked. Instantiate in JavaScript with
 *
 * new MadGTrack();
 *
 * Thanks!
 *
 * http://madg-analytics.madgbeta.com/madg-track/
 *
 */

(function () {
  this.MadgTrack = function () {
    // Define option defaults
    var defaults = {
      dataLayerName: "dataLayer",
      devMode: false,
    };

    // Create options by extending defaults with the passed in arugments
    if (arguments[0] && typeof arguments[0] === "object") {
      this.options = extendDefaults(defaults, arguments[0]);
    } else {
      this.options = extendDefaults(defaults);
    }

    // Run initial methods
    this.init();
  };

  // Private methods
  function extendDefaults(source, properties) {
    var property;
    if (properties) {
      for (property in properties) {
        if (properties.hasOwnProperty(property)) {
          source[property] = properties[property];
        }
      }
    }
    return source;
  }

  function lowerCaseFirstLetter(string) {
    return string.charAt(0).toLowerCase() + string.slice(1);
  }

  // Public methods
  MadgTrack.prototype.getDataLayerVariablesFromHTML = function () {
    var dlKeyVals = {};
    var madgVarEls = document.querySelectorAll("[data-madg-var]");
    var madgVarsEls = document.querySelectorAll("[data-madg-vars]");
    madgVarEls.forEach(
      function (el) {
        if (el.dataset.madgVar) {
          var dlKey = el.dataset.madgVar;
          var dlVal = el.textContent
            ? el.textContent.replace(/\n/g, " ").replace(/\s\s*/g, " ").trim()
            : "";
          if (!dlVal) {
            this.warn(
              "You failed to provide text content in an element with a data-madg-var attribute."
            );
          }
          dlKeyVals[dlKey] = dlVal;
        }
      }.bind(this)
    );
    madgVarsEls.forEach(
      function (el) {
        var elDataset = el.dataset;
        var elDataLayerVars = {};
        for (var dataKey in elDataset) {
          if (dataKey === "madgVars") {
            continue;
          }
          if (elDataset.hasOwnProperty(dataKey)) {
            var dataKeyFormatted = lowerCaseFirstLetter(dataKey.slice(7));
            if (dataKeyFormatted) {
              elDataLayerVars[dataKeyFormatted] = elDataset[dataKey];
            }
          }
        }
        Object.assign(dlKeyVals, elDataLayerVars);
      }.bind(this)
    );
    return dlKeyVals;
  };

  MadgTrack.prototype.pushToDataLayer = function (dataLayerVariables) {
    if (window[this.options.dataLayerName]) {
      window[this.options.dataLayerName].push(
        Object.assign({}, dataLayerVariables)
      );
    } else {
      this.warn(
        "The dataLayer variable, or the variable name you gave when instantiating MadgTrack, does not exist."
      );
    }
  };

  MadgTrack.prototype.setCustomEventHandlersFromHTML = function () {
    var eventEls = document.querySelectorAll("[data-madg-custom-event]");
    eventEls.forEach(
      function (el) {
        if (el.nodeName === "A" || el.nodeName === "BUTTON") {
          el.addEventListener(
            "click",
            function handleCustomEventClick(event) {
              var eventDataset = event.target.dataset;
              var eventName = eventDataset.madgCustomEvent;
              var customEventVars = {};
              for (var custEvKey in eventDataset) {
                if (eventDataset.hasOwnProperty(custEvKey)) {
                  var custEvKeyFormatted = lowerCaseFirstLetter(
                    custEvKey.slice(15)
                  );
                  if (custEvKeyFormatted) {
                    customEventVars[custEvKeyFormatted] =
                      eventDataset[custEvKey];
                  }
                }
              }
              if (eventName && Object.keys(customEventVars).length) {
                this.pushToDataLayer(
                  Object.assign(
                    {
                      event: eventName,
                    },
                    customEventVars
                  )
                );
              } else if (eventName) {
                this.pushToDataLayer({
                  event: eventName,
                });
              } else {
                this.warn(
                  "You may have failed to add a value to a data-madg-custom-event attribute."
                );
              }
            }.bind(this)
          );
        }
      }.bind(this)
    );
  };

  MadgTrack.prototype.setEventHandlersFromHTML = function () {
    var eventEls = document.querySelectorAll("[data-madg-event-category]");
    eventEls.forEach(
      function (el) {
        if (el.nodeName === "A" || el.nodeName === "BUTTON") {
          el.addEventListener(
            "click",
            function handleEventClick(event) {
              var evDataset = event.target.dataset;
              var cat = evDataset.madgEventCategory;
              var act = evDataset.madgEventAction;
              var lab = evDataset.madgEventLabel;
              var val = evDataset.madgEventValue;
              if (!cat || !act || !lab) {
                this.warn(
                  "Events require at least a category, action, and label."
                );
              } else {
                this.pushToDataLayer({
                  event: "madgEvent",
                  madgEventCat: cat,
                  madgEventAct: act,
                  madgEventLab: lab,
                  madgEventVal: val ? val : "0",
                });
              }
            }.bind(this)
          );
        }
      }.bind(this)
    );
  };

  MadgTrack.prototype.warn = function (msg) {
    if (this.options.devMode && typeof msg === "string") {
      console.warn(msg);
    }
  };

  MadgTrack.prototype.init = function () {
    this.pushToDataLayer(this.getDataLayerVariablesFromHTML());
    this.setCustomEventHandlersFromHTML();
    this.setEventHandlersFromHTML();
  };
})();
